import { Grid, Typography } from "@mui/material";

import { FairPaySurveyResponse } from "features/FairPaySurvey/schemas";

import PieChart from "./PieChart";

const styles = {
  badge: {
    my: 2,
    background: "white",
    p: 2,
    borderRadius: "20px",
    border: `1px solid #DFDFDF`,
  },
  chip: {
    py: 1,
    px: 2,
    mb: 1,
    fontWeight: 700,
    fontSize: "18px",
    color: "#151F16",
    borderRadius: "20px",
    border: `1px solid rgba(21, 31, 22, 0.2)`,
  },
  descriptionLargeText: {
    textAlign: "center",
    fontSize: "28px",
    fontWeight: 600,
  },
  descriptionText: { textAlign: "center", maxWidth: "80%" },
};

export default function LocationPercentile({
  surveyResponse,
}: {
  surveyResponse: FairPaySurveyResponse | null;
}) {
  if (!surveyResponse) {
    return null;
  }

  if (!surveyResponse?.locationPercentile) {
    return null;
  }

  const topPercentage =
    100 - Math.round(surveyResponse.locationPercentile) || 1;

  return (
    <Grid item xs={12} justifyContent="center" container sx={styles.badge}>
      <Typography component="div" sx={styles.chip}>
        {surveyResponse.country}
      </Typography>
      <Grid item xs={12} justifyContent="center" container>
        <Typography sx={styles.descriptionLargeText}>
          👏 Top {topPercentage}%
        </Typography>
      </Grid>
      <Grid item xs={12} justifyContent="center" container sx={{ my: 2 }}>
        <PieChart percentage={topPercentage} />
      </Grid>
      <Grid item xs={12} justifyContent="center" container>
        <Typography sx={styles.descriptionText}>
          In {surveyResponse.country}, you're in the top {topPercentage}% of
          earners!
        </Typography>
      </Grid>
    </Grid>
  );
}
